// based on UserRoles: features/issue/src/models/user-roles.ts
export type IssuePermissions =
  | 'isIssueTypeManager'
  | 'isApprover'
  | 'isCreator'
  | 'isOwner'
  | 'isActionOwner'
  | 'isActionApprover'
  | 'isWatcher';

export enum IssuePermissionsEnum {
  IsIssueTypeManager = 'isIssueTypeManager',
  IsApprover = 'isApprover',
  IsCreator = 'isCreator',
  IsOwner = 'isOwner',
  IsActionOwner = 'isActionOwner',
  IsActionApprover = 'isActionApprover',
  IsWatcher = 'isWatcher',
}
